/* angular:styles/component:css;0db617f87683e095e99190bf4a6b34dc7658a4f1aaea0213a8675c33436dc91f;/src/src/app/shared/components/picktime/picktime.component.ts */
.datetime-button::part(native) {
  background-color: var(--ion-color-toolbar-primary);
}
.datetime-button::part(content) {
  padding: 0 !important;
}
.picker-opts {
  --background: none;
}
/*# sourceMappingURL=picktime.component.css.map */
